<template>
  <div
    class="header-nav"
    :class="{ showShadow }"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    @mousewheel.prevent="mousewheel"
  >
    <div>
      <div>
        <div class="left">
          <img src="@/assets/images/logo.png" style="width: 46px; height: 35px" />
          <span v-if="title">{{ title }}</span>
        </div>
        <div class="center">
          <div>
            <ul>
              <template v-for="(item, i) in routerLilst">
                <template v-if="!item.menuHidden">
                  <li v-if="item.href" class="href" type="href" :key="i" @click.stop="handleCommand(item)">
                    {{ item.menuName }}
                  </li>
                  <el-dropdown v-else-if="!isNoChild(item)" placement="bottom" @command="handleCommand">
                    <li
                      :class="{
                        'router-link-active': isActive(item.menuUrl),
                      }"
                      @click.stop="handleCommand(item)"
                    >
                      {{ item.menuName }}
                    </li>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="nav in item.children" :key="nav.menuUrl" :command="nav">
                        <template v-if="!nav.menuHidden">
                          <router-link v-if="nav.menuUrl" :key="i" :to="nav.menuUrl" tag="li">
                            {{ nav.menuName }}
                          </router-link>
                          <li v-else :key="i">{{ nav.menuName }}</li>
                        </template>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <router-link v-else :key="i" :to="item.menuUrl" tag="li">{{ item.menuName }}</router-link>
                </template>
              </template>
            </ul>
          </div>
          <div class="progress"><div class="bar" /></div>
        </div>
        <div class="right">
          <div v-show="!token" @click.stop="bindClick('1')">登录</div>
          <div v-show="!token" @click.stop="bindClick('3')">注册</div>
          <div v-show="token" @click.stop="bindClick('4')">工作台</div>
          <div v-show="token" @click.stop="bindClick('5')">退出登录</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PROJECT_NAME, REGISTER_URL } from "@/config";
import { getToken, TokenKey } from "@/utils/auth";
import { addEvent, removeEvent } from "@/utils/eventList";
import { getList } from "@/api/menus";
export default {
  name: "HeaderNav",
  data() {
    return {
      title: PROJECT_NAME,
      routerLilst: [],
      showShadow: false,
    };
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
  methods: {
    initData() {
      getList().then(res => {
        this.routerLilst = this.checkMenu(res.data);
      });
    },
    checkMenu(arr) {
      let out = [];
      if (arr && arr.length) {
        arr.forEach(item => {
          let obj = { menuName: item.menuName, menuHidden: !!item.menuHidden, menuUrl: "", href: "", children: null };
          if (this.isHttp(item.menuUrl)) {
            obj.href = item.menuUrl;
          } else {
            obj.menuUrl = item.menuUrl;
          }
          let children = this.checkMenu(item.children);
          if (children && children.length) {
            obj.children = children;
          }
          out.push(obj);
        });
      }
      return out && out.length ? out : null;
    },
    isHttp(str) {
      if (!str) {
        return false;
      } else if (str.indexOf("http:") == 0 || str.indexOf("https:") == 0) {
        return true;
      }
    },
    initProgress() {
      this.$nextTick(() => {
        var progress = document.querySelector(".progress"),
          bar = progress.querySelector(".bar"),
          tar = document.querySelector(".header-nav .center > div");
        // console.log(tar.offsetWidth, tar.scrollWidth, bar);
        if (tar && tar.offsetWidth < tar.scrollWidth) {
          progress.style.opacity = 1;
          bar.style.width = ((progress.offsetWidth - 4) * tar.offsetWidth) / tar.scrollWidth + "px";
          bar.style.left = 2 + ((progress.offsetWidth - 4) * tar.scrollLeft) / tar.scrollWidth + "px";
        } else {
          progress.style.opacity = 0;
        }
      });
    },
    mouseenter() {
      try {
        let progress = document.querySelector(".progress");
        progress.style.visibility = "visible";
        this.initProgress();
      } catch (error) {
        console.error(error);
      }
    },
    mouseleave() {
      try {
        let progress = document.querySelector(".progress");
        progress.style.visibility = "hidden";
        this.initProgress();
      } catch (error) {
        console.error(error);
      }
    },
    mousewheel(e) {
      if (e.deltaY != null && e.deltaY != undefined) {
        let tar = document.querySelector(".header-nav .center > div"),
          scrollWidth = tar.scrollWidth,
          left = tar.scrollLeft;
        // 有滑动空间
        if (tar.offsetWidth < tar.scrollWidth) {
          left += e.deltaY;
          // 下滑转右滑
          if (e.deltaY > 0) {
            left = left > scrollWidth ? scrollWidth : left;
          } else {
            // 上滑转左滑
            left = left < 0 ? 0 : left;
          }
          // console.log("mousewheel", e, tar, tar.offsetWidth, tar.scrollWidth, tar.scrollLeft, left);
          tar.scroll(left, 0);
          let progress = document.querySelector(".progress"),
            bar = progress.querySelector(".bar");
          bar.style.left = 2 + ((progress.offsetWidth - 4) * tar.scrollLeft) / tar.scrollWidth + "px";
        }
      }
    },
    scrollEvent() {
      this.showShadow = (window.scrollY || window.scrollTop || 0) >= 50;
      // console.log("window.scrollX", );
      document.querySelector(".header-nav>div").scrollTo(window.scrollX, 0);
    },
    handleCommand(nav) {
      // console.log("handleCommand", nav);
      if (nav.alert) {
        alert(nav.alert);
      } else if (nav.href) {
        window.open(nav.href);
      } else if (!this.isExactActive(nav.menuUrl)) {
        this.$router.push({ path: nav.menuUrl }).catch(error => {});
      }
    },
    isActive(path) {
      // console.log("router-link-active ", this.$route.path, path);
      return this.$route.path.indexOf(path) === 0;
    },
    isExactActive(path) {
      // console.log("router-link-exact-active ", this.$route.path, path);
      return this.$route.path === path;
    },
    alertInfo(tar) {
      alert(tar.alert);
    },
    async bindClick(type) {
      if (type === "4") {
        window.open(window.location.origin + "/#/staging");
      } else if (type === "5") {
        this.$confirm("确认退出登录？")
          .then(async () => {
            await this.$store.dispatch("user/logout");
            done();
          })
          .catch(_ => {});
      } else if (type === "3") {
        // 当前页面完整路径
        const url = encodeURIComponent(window.location.href);
        window.location.href = REGISTER_URL + "?redirect=" + url;
      } else {
        this.$router.push({ path: "/login", query: { type, redirect: this.$route.fullPath } });
      }
    },
    /**
     * 后台退出登录时门户端刷新token状态->更新登录状态
     */
    storageEvent(event) {
      if (event && event.key === TokenKey) {
        this.$store.commit("user/SET_TOKEN", getToken());
      }
    },
    isNoChild(tar) {
      let flag = true;
      if (tar && tar.children && tar.children.length) {
        for (let i = 0; i < tar.children.length; i++) {
          let child = tar.children[i];
          if (child && !child.menuHidden) {
            flag = false;
            break;
          }
        }
      }
      return flag;
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.initProgress();
    window._addScrollFun("header-nav", this.scrollEvent);
    addEvent("storage", TokenKey, this.storageEvent);
  },
  beforeDestroy() {
    window._removeScrollFun("header-nav");
    removeEvent("storage", TokenKey);
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
<style lang="less">
.el-dropdown-menu__item .router-link-active {
  color: #0044cb !important;
}
</style>
